export default function Security() {
  const securityFeatures = [
    {
      icon: 'ri-lock-password-line',
      title: 'AES 256-bit Encryption',
      description: 'Military-grade encryption standard'
    },
    {
      icon: 'ri-shield-keyhole-line',
      title: 'Kill Switch Protection',
      description: 'Automatic disconnect if VPN drops'
    },
    {
      icon: 'ri-file-shield-line',
      title: 'DNS Leak Protection',
      description: 'Prevents DNS request leaks'
    },
    {
      icon: 'ri-spy-line',
      title: 'No Activity Logs',
      description: 'Zero tracking of your online activity'
    },
    {
      icon: 'ri-shield-flash-line',
      title: 'Secure Protocols',
      description: 'OpenVPN, IKEv2, WireGuard support'
    },
    {
      icon: 'ri-fingerprint-line',
      title: 'Anonymous Browsing',
      description: 'Hide your IP and location'
    }
  ];

  return (
    <section id="security" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          <div>
            <h3 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-6">
              <strong>Bank-Level Security</strong> for Your Privacy
            </h3>
            <p className="text-xl text-gray-600 mb-8 leading-relaxed">
              SALVI VPN uses the most advanced security protocols and encryption standards to protect your data. Our VPN application ensures that your online activities remain private and secure from hackers, ISPs, and government surveillance.
            </p>
            
            <div className="space-y-6 mb-10">
              <div className="flex items-start">
                <div className="w-6 h-6 flex items-center justify-center bg-teal-100 rounded-full mr-4 mt-1 flex-shrink-0">
                  <i className="ri-check-line text-teal-600 text-sm"></i>
                </div>
                <div>
                  <h5 className="font-semibold text-gray-900 mb-1">Zero-Knowledge Architecture</h5>
                  <p className="text-gray-600">We cannot access your data even if we wanted to. Your privacy is guaranteed by design.</p>
                </div>
              </div>
              
              <div className="flex items-start">
                <div className="w-6 h-6 flex items-center justify-center bg-teal-100 rounded-full mr-4 mt-1 flex-shrink-0">
                  <i className="ri-check-line text-teal-600 text-sm"></i>
                </div>
                <div>
                  <h5 className="font-semibold text-gray-900 mb-1">Regular Security Audits</h5>
                  <p className="text-gray-600">Our systems undergo regular third-party security audits to ensure maximum protection.</p>
                </div>
              </div>
              
              <div className="flex items-start">
                <div className="w-6 h-6 flex items-center justify-center bg-teal-100 rounded-full mr-4 mt-1 flex-shrink-0">
                  <i className="ri-check-line text-teal-600 text-sm"></i>
                </div>
                <div>
                  <h5 className="font-semibold text-gray-900 mb-1">Transparent Privacy Policy</h5>
                  <p className="text-gray-600">Clear and honest about what we do and don't collect. No hidden terms or conditions.</p>
                </div>
              </div>
            </div>

            <button 
              onClick={() => {
                const element = document.getElementById('contact');
                if (element) element.scrollIntoView({ behavior: 'smooth' });
              }}
              className="bg-teal-600 text-white px-8 py-4 rounded-full text-lg font-semibold hover:bg-teal-700 transition-all shadow-lg hover:shadow-xl cursor-pointer whitespace-nowrap"
            >
              Learn More About Security
            </button>
          </div>

          <div className="relative">
            <div className="relative rounded-2xl overflow-hidden shadow-2xl">
              <img 
                src="https://public.readdy.ai/ai/img_res/c59914f75bfc8319c81366d9660185cb.jpg"
                alt="VPN Security and Privacy Protection"
                title="SALVI VPN Security Features"
                className="w-full h-full object-cover object-top"
              />
            </div>
            
            <div className="absolute -bottom-8 -left-8 bg-white p-6 rounded-xl shadow-xl border border-gray-100">
              <div className="flex items-center space-x-4">
                <div className="w-12 h-12 flex items-center justify-center bg-green-100 rounded-full">
                  <i className="ri-shield-check-fill text-2xl text-green-600"></i>
                </div>
                <div>
                  <div className="text-2xl font-bold text-gray-900">100%</div>
                  <div className="text-sm text-gray-600">Secure Connection</div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="mt-20 grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-6">
          {securityFeatures.map((feature, index) => (
            <div key={index} className="text-center p-6 bg-gradient-to-br from-gray-50 to-white rounded-xl border border-gray-100 hover:shadow-lg transition-all">
              <div className="w-12 h-12 flex items-center justify-center bg-teal-100 rounded-full mx-auto mb-4">
                <i className={`${feature.icon} text-2xl text-teal-600`}></i>
              </div>
              <h5 className="font-semibold text-gray-900 mb-2 text-sm">{feature.title}</h5>
              <p className="text-xs text-gray-600">{feature.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
